@if (entries().length === 0) {
	<nz-empty nzNotFoundContent="No stride log entries found for these filters."></nz-empty>
} @else {
	<nz-timeline>
		@for (entry of entries(); track entry.uuid) {
			<nz-timeline-item [nzColor]="stepColor(entry.stepKey)">
				<div class="entry-header">
					<span class="entry-sequence" nz-tooltip nzTooltipTitle="Order this step occurred in">
						#{{ entry.sequence + 1 }}
					</span>
					<nz-tag [nzColor]="stepColor(entry.stepKey)">{{ stepLabel(entry.stepKey) }}</nz-tag>
					<span class="entry-group">{{ groupLabel(entry.stepGroup) }}</span>
					<span class="entry-date">{{ entry.created | date: 'MMM d, y h:mm:ss a' }}</span>
				</div>
				<div class="entry-message">{{ entry.message }}</div>
				<div class="entry-meta">
					@if (entry.skillCode) {
						<span>Skill: {{ entry.skillCode }}</span>
					}
					@if (entry.rubricLevelLevel != null) {
						<app-rubric-level-badge [level]="entry.rubricLevelLevel"></app-rubric-level-badge>
					}
				</div>
				@if (getAssessmentDetails(entry); as assessment) {
					@if (assessment.userText) {
						<p class="assessment-user-text"><strong>Student's Response:</strong> {{ assessment.userText }}</p>
					}
					<nz-collapse class="assessment-details">
						<nz-collapse-panel nzHeader="Assessment Details" [nzActive]="true">
							@if (assessment.strideScoreReason) {
								<p><strong>Score Reasoning:</strong> {{ assessment.strideScoreReason }}</p>
							}
							@if (assessment.strideLevelReason) {
								<p><strong>Level Reasoning:</strong> {{ assessment.strideLevelReason }}</p>
							}
							@if (assessment.strideScoreMath; as math) {
								<p>
									<strong>Score Breakdown:</strong>
									{{ math.sum_of_scores }} / {{ math.max_possible }} points across
									{{ math.num_questions }} question(s) ({{ math.raw_percentage | number: '1.0-1' }}%)
								</p>
							}
							@if (assessment.scoreCounts; as counts) {
								<p>
									<strong>Proficiency Score Counts:</strong>
									1s: {{ counts.ones }}, 2s: {{ counts.twos }}, 3s: {{ counts.threes }}
								</p>
							}
						</nz-collapse-panel>
					</nz-collapse>
				}
				@if (getStartingConfiguration(entry); as skillConfigs) {
					<nz-collapse class="starting-configuration">
						<nz-collapse-panel nzHeader="Starting Configuration" [nzActive]="true">
							<nz-table [nzData]="skillConfigs" [nzShowPagination]="false" nzSize="small">
								<thead>
									<tr>
										<th>Skill</th>
										<th>User's Level</th>
										<th>Recent Scores</th>
										<th>Prediction</th>
									</tr>
								</thead>
								<tbody>
									@for (config of skillConfigs; track config.skillCode) {
										<tr [class.no-history]="!config.hasHistory">
											<td class="skill-cell">{{ config.skillCode }}</td>
											<td>
												<app-rubric-level-badge [level]="config.currentLevel"></app-rubric-level-badge>
												@if (!config.hasHistory) {
													<span class="default-badge">Default</span>
												}
											</td>
											<td>
												@if (config.recentPercentages.length > 0) {
													{{ config.recentPercentages.join('%, ') }}%
												} @else {
													—
												}
											</td>
											<td>{{ predictionLabel(config.prediction) }}</td>
										</tr>
									}
								</tbody>
							</nz-table>
						</nz-collapse-panel>
					</nz-collapse>
				}
				@if (getStartingContentSet(entry); as contentAvailability) {
					<nz-collapse class="starting-content-set">
						<nz-collapse-panel nzHeader="Starting Content Set" [nzActive]="true">
							<nz-table [nzData]="contentAvailability" [nzShowPagination]="false" nzSize="small">
								<thead>
									<tr>
										<th>Skill</th>
										<th>Activities Per Level</th>
										<th>Activities For User's Level</th>
										<th>Fresh Remaining</th>
									</tr>
								</thead>
								<tbody>
									@for (availability of contentAvailability; track availability.skillCode) {
										<tr>
											<td class="skill-cell">{{ availability.skillCode }}</td>
											<td>
												<div class="level-counts-cell">
													@for (lc of availability.levelCounts; track lc.level) {
														<app-rubric-level-badge [level]="lc.level" label="L">
															: {{ lc.totalActivities }}
														</app-rubric-level-badge>
													} @empty {
														<span>—</span>
													}
												</div>
											</td>
											<td>
												<app-rubric-level-badge [level]="availability.currentLevel">
													: {{ availability.totalAtCurrentLevel }}
												</app-rubric-level-badge>
											</td>
											<td>{{ availability.freshRemainingAtCurrentLevel }}</td>
										</tr>
									}
								</tbody>
							</nz-table>
						</nz-collapse-panel>
					</nz-collapse>
				}
			</nz-timeline-item>
		}
	</nz-timeline>
}
